// tslint:disable: no-unused-expression
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'localStringToNumber' })
export class LocalStringToNumberPipe implements PipeTransform {

  /** En caso de modificar el pipe también se debe modifica la función en el back Model/common/ajx_build_reports -> stringToNumber */

  /* transform(): Pipe que devuelve un número a partir de un texto con formato categorizado
    value: Valor categorizado (formato moneda, porcentaje, miles)
    type: categoría del tetxo
  */
  transform(value: any, type: string = 'local'): number {
    // ↓ Si el valor esta vacío convierte a 0
    value = value ? value : "0";
    // response: Valor que se retornará
    let response = 0;
    if (type === 'currency') {
      // ↓ Elimina los signos '$' y ',', apartir del signo '.' elimina el resto de la cadena
      response = parseFloat(value.toString().replace(/[$]/g, '').replace(/[.]/g, '').replace(/(?:\,),{1,2}/g, ""));
    } else if (type === 'local') {
      // ↓ Elimina los signos '.' y convierte los signos ',' en '.'
      response = parseFloat(value.toString().replace(/[.]/g, '').replace(/[,]/g, "."));
    } else if (type === 'string') {
      // ↓ formatea string a number
      response = parseFloat(value);
    } else if (type === 'percentage') {
      // ↓ Convierte los signos ',' en '.'
      response = parseFloat(value.toString().replace(/[,]/g, '.'));
    } else if (type === 'percent') {
      // ↓ Convierte los signos ',' en '.' y elimina el signo de % de un valor
      response = Number(value.toString().replace(/[,]/g, '/').replace(/[.]/g, '').replace(/[/]/g, '.').replace(/[%]/g, '').trim());
    } else if (type === "fullCurrency") {
      // ↓ Elimina los signos '$' y '.' y convierte ',' a '.'
      response = isNaN(value) ? Number(`${value}`.replace(/[$]/g, '').replace(/[.]/g, '').replace(/[,]/g, '.')) : +value;
    } else if (type === "time") {
      // ↓ Suma la cantidad de horas, minutos y segundos de una cadena con formato hh:mm:ss
      response = Number(value.split(':').reduce((pre: number, cur: number) => (60 * pre) + +cur));
    } else if (type === "date") {
      // ↓ Crea una fecha a partir de una cadena con formato aaaa-mm-dd hh:mm:ss
      response = new Date(value.length <= 10 ? `${value} 00:00:00` : value).getTime();
    }
    // ↓ si el resultado no es un numérico convierte a 0
    isNaN(response) ? response = 0 : null;
    // ↓ Devuelve el valor convertido en número
    return response;
  }

}
